import { Tooltip } from "components";
import { InfoMessage } from 'components';
import { bool } from "prop-types";
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import Label from 'components/fieldLabel';
import { saveAs } from "file-saver";
import docSupDespDeclar from 'assets/documents/Υπόδειγμα_Δήλωσης_ΜΜΕ.docx';
import DeMinimins from 'assets/documents/ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS 2023.docx';
import DeMiniminsGuide from 'assets/documents/ΟΔΗΓΟΣ ΣΥΜΠΛΗΡΩΣΗ_ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS.pdf';
import { Link } from "@mui/material";


export const contentAdditional = (ownerStatus, residence) =>
  [
    {
      label: <Label 
        label={<span>
        <strong>Επιπλέον Δικαιολογητικά</strong>{' '}
        {!(ownerStatus === 'ownerStatusOwner' && residence) ? <>
          <span style={{ fontWeight: 400, fontSize: 11 }}>
            (Κατεβάστε το ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS 2023{' '}
            <Link component="button" underline="always"
                  onClick={() => saveAs(DeMinimins, 'ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS 2023')}>
              εδώ
            </Link>
            )
          </span>
          {' '}
          <span style={{ fontWeight: 400, fontSize: 11 }}>
            (Κατεβάστε τον ΟΔΗΓΟΣ ΣΥΜΠΛΗΡΩΣΗ_ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS{' '}
            <Link component="button" underline="always"
                  onClick={() => saveAs(DeMiniminsGuide, 'ΟΔΗΓΟΣ ΣΥΜΠΛΗΡΩΣΗ_ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS')}>
              εδώ
            </Link>
            )
          </span>
        </>
        : ''
      }
      </span>}
        asterisk={true}
      />,
      // label: <div style={{display:'flex', marginRight:'5px'}}>
      //           <b>Επιπλέον Δικαιολογητικά</b><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupDespDeclar, "Υπόδειγμα Υπεύθυνης Δήλωσης")}>εδώ</a>)</text>
      // </div>,
      fileCode: 'benAdditionalDocs',
      id: 'benAdditionalDocs',
      multiple: true,
      fileLimit: 10
    },
  ].filter(item => item);